export default [
    "Factorial",
    "Fibonacci",
    "GCD",
    "Hanoi",
    "Lists",
    "Trees"
];


// WEBPACK FOOTER //
// ./src/listPerfProgs.js